export function convertCaseBoxList(data, field) {
    const array = [];
    if (Array.isArray(data) && Array.isArray(field)) {
        field.forEach((e, i) => {
            array.push(convertCaseBox(data[i], e));
        });
    } else {
        array.push(convertCaseBox(data, field));
    }
    return array;
};

export function convertCaseBox(data, field) {
    if (!data || !field) {
        throw new Error('Data.IsNull');
    }
    const arr = [];
    Object.entries(field).forEach(([key, value]) => {
        if (typeof value === 'string' && value) {
            if (data[key]) {
                // if (dataKeys.includes(key)) {
                arr.push(setBoxData(field[key], data[key]));
            }
        }
    });
    return {
        title: arr && arr.length > 0 ? field?.title : '',
        list: arr,
    };
};

export function setBoxData(k, v) {
    return {
        key: k,
        value: v,
    };
};
